// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YElWT","comment":"styles_comment__b5_vG"};